module.exports = __webpack_public_path__ + "media/assets/images/logo-ace-af988e1b6c5f46d23cd82bde348c792d.png";